import { render, staticRenderFns } from "./CharacterPortraitEditor.vue?vue&type=template&id=3d35a8e5&lang=pug&"
import script from "./CharacterPortraitEditor.vue?vue&type=script&lang=js&"
export * from "./CharacterPortraitEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CharacterPortraitEditor.vue"
export default component.exports